import MimeTypeFilter from "../../document/mimetype/MimeTypeFilter";
import PortalDocument from "../../document/PortalDocument";
import MimeTypes from "../../document/mimetype/MimeTypes";
import FileTypeGroupFilter from "../../document/mimetype/FileTypeGroupFilter";
import FileTypeGroup from "../../document/mimetype/FileTypeGroup";
import MimeType from "../../document/mimetype/MimeType";
import {Parameter as ParameterType} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../../../shared/helper/FunctionHelper";

export default class Parameter<T_PARAMETER_TYPE extends ParameterType> {
	private readonly mimeTypeFilter: MimeTypeFilter;
	private readonly fileTypeGroupFilter: FileTypeGroupFilter;
	private _data: T_PARAMETER_TYPE;

	constructor(
		parameter: T_PARAMETER_TYPE, mimeTypeFilter?: MimeTypeFilter, fileTypeGroupFilter?: FileTypeGroupFilter
	) {
		this.mimeTypeFilter = FunctionHelper.applyValue(
			mimeTypeFilter, new MimeTypeFilter([], [MimeTypes.ALL])
		);
		this.fileTypeGroupFilter = FunctionHelper.applyValue(
			fileTypeGroupFilter, new FileTypeGroupFilter([], [FileTypeGroup.ALL])
		);
		this._data = parameter;
	}

	public isSupported(selection: Array<PortalDocument>) {
		let mimeTypes: Array<MimeType> = [];
		let fileTypeGroups: Array<string> = [];

		for (let selectedDocument of selection) {
			mimeTypes.push(selectedDocument.getMimeType());
			fileTypeGroups.push(selectedDocument.getFileTypeGroup());
		}

		return this.mimeTypeFilter.checkSelection(mimeTypes) && this.fileTypeGroupFilter.checkSelection(fileTypeGroups);
	}

	get data(): T_PARAMETER_TYPE {
		return this._data;
	}

	set data(value: T_PARAMETER_TYPE) {
		this._data = value;
	}

	public clone(): Parameter<T_PARAMETER_TYPE> {
		return new Parameter<T_PARAMETER_TYPE>(
			this._data.clone(),
			new MimeTypeFilter(
				this.mimeTypeFilter.blacklist,
				this.mimeTypeFilter.whitelist
			),
			new FileTypeGroupFilter(
				this.fileTypeGroupFilter.blacklist,
				this.fileTypeGroupFilter.whitelist
			)
		);
	}
}